export default __webpack_public_path__ + "static/media/success.2de154ee.svg";